import Gradient384 from './Gradient384';

export default Gradient384;
